import React from "react";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

export default class InfoToolTip extends React.PureComponent {
  render() {
    const { className, noHover, icon, placement, title, children, ...retProps } = this.props;

    return (
      <div className={styles.infoToolTip + " " + (className ? className : "")} {...retProps}>
        <OverlayTrigger
          placement={placement ? placement : "top"}
          trigger={noHover ? [] : ["hover", "click"]}
          rootClose
          overlay={
            <Popover id={"popover-positioned-" + (placement ? placement : "top")} title={title}>
              {children}
            </Popover>
          }
        >
          {icon ? icon : <FontAwesomeIcon icon={faInfo} className={styles.infoToolTipIcon} />}
        </OverlayTrigger>
      </div>
    );
  }
}
